import { BugsnagAdapter } from "commons/BugsnagAdapter";

export class ComponentObserver {
  constructor(eventName = "element:onviewport", config = {}) {
    this.eventName = eventName;
    this.config = Object.assign(config, {
      root: null,
      rootMargin: "0px",
      treshold: [0],
      intersectionRatio: null,
    });
    this.observer = new IntersectionObserver(this.callback.bind(this));
  }

  observe(selector) {
    try {
      if (selector.length <= 0) return;
      this.applyMethod(selector, "observe");
    } catch (e) {
      BugsnagAdapter.notify("ComponentObserver.observe", e);
    }
  }

  unobserve(selector) {
    try {
      if (selector.length <= 0) return;
      this.applyMethod(selector, "unobserve");
    } catch (e) {
      BugsnagAdapter.notify("ComponentObserver.unobserve", e);
    }
  }

  isObject(val) {
    return (
      (typeof val === "object" || typeof val === "function") && val !== null
    );
  }

  applyMethod(selector, method) {
    if (!this.isObject(selector)) return;

    if (selector.length === undefined) {
      this.observer[method](selector);
    } else {
      selector.forEach((el) => {
        this.observer[method](el);
      });
    }
  }

  callback(entries) {
    let ev = new Event(`vidio:${this.eventName}`);
    entries.forEach((entry) => {
      if (entry.isIntersecting) entry.target.dispatchEvent(ev);
    });
  }
}
